export class UsernameIsInvalidError extends Error {}

export class PasswordIsInvalidError extends Error {}
